import { ref, computed } from 'vue'
import { defineStore } from 'pinia';
import useAdConfigurationGlobals from '@/composables/useAdConfigurationGlobals';

const { $GPT_PRIMARY_ACTIVITY, $AD_SOURCE, $AD_SLOT_INFO } = useAdConfigurationGlobals();

export let useMapAdStore = defineStore('mapAdStore', () => {
  let blockingAdPanelOpen = ref(false);
  let activeAd = null;
  let adFilled = ref(true);
  let adContainerId = ref(null);
  let refreshAllowed = ref(true);
  let mapProductAdSlots = ref([
    {
      productId: 18,
      id: $AD_SOURCE === 'gpt' ? `MREC_${$GPT_PRIMARY_ACTIVITY}` : 'map_flow_med_rect'
    }
  ])
  
  const defaultSlot = computed(() => $AD_SOURCE === 'gpt' ? `MREC_${$GPT_PRIMARY_ACTIVITY}` : 'map_med_rect')

  let currentAdSlot = ref(defaultSlot.value);

  function changeAdSlot(productId) {
    if (!adFilled.value) return;
    
    const adSlot = mapProductAdSlots.value.find(adSlot => adSlot.productId === parseInt(productId));
    
    currentAdSlot.value = adSlot ? adSlot.id : defaultSlot.value;
  }

  function initAd(containerId) {  
    const accountId = $AD_SLOT_INFO[$AD_SOURCE].accountId;
    adContainerId.value = containerId || adContainerId.value;
    
    window.googletag = window.googletag || { cmd: [] }

    googletag.cmd.push(() => {
      activeAd = googletag
        .defineSlot(`/${accountId}/${currentAdSlot.value}`, [300, 250], adContainerId.value)
        .addService(googletag.pubads())       

      googletag.pubads().disableInitialLoad();
      googletag.enableServices();
    });

    blockRefresh(20000)
    displayAd();
  }

  function displayAd() {
    if (!adFilled.value) return

    googletag.cmd.push(() => {
      googletag.display(currentAdSlot.value);
      googletag.pubads().refresh([activeAd]);

      googletag.pubads().addEventListener('slotRenderEnded', function (event) {
        if (event.isEmpty) {
          adFilled.value = false
        }
      })       

    });
  }

  function refreshAd() {
    if (!activeAd || !adFilled.value || !refreshAllowed.value) return;

    googletag.cmd.push(() => {
      googletag.pubads().refresh([activeAd])
    })

    blockRefresh();
  }

  function blockRefresh(delay = 10000) {
    refreshAllowed.value = false

    setTimeout(() => {
      refreshAllowed.value = true
    }, delay)
  }

  function removeAdSlot() {   
    if (activeAd) {
      window.googletag = window.googletag || { cmd: [] }
      
      googletag.destroySlots([activeAd]);
      activeAd = null;
    }
  }

  window.$EventBus.addEventListener('change-ad-slot', (e) => {
    changeAdSlot(e.detail.viewId);
  }) 

  return {
    blockingAdPanelOpen,
    currentAdSlot,
    adFilled,
    changeAdSlot,
    initAd,
    displayAd,
    refreshAd,
    removeAdSlot
  }
});
